import { apiService } from './api';
import { AdjustSenderPostageRequest, AdjustPostageResult } from '../types';

class ContactService {
  /**
   * Adjust postage requirement for a sender.
   * If sender is not in address book, adds them first.
   */
  async adjustSenderPostage(request: AdjustSenderPostageRequest): Promise<AdjustPostageResult> {
    return apiService.post<AdjustPostageResult>('/api/contacts/adjust-sender-postage', request);
  }

  /**
   * Get required postage for sending to a recipient
   * (checks if recipient has sender-specific rate in their address book)
   */
  async getRequiredPostage(recipientUsername: string): Promise<{ requiredPostage: number }> {
    return apiService.get<{ requiredPostage: number }>(`/api/contacts/required-postage/${recipientUsername}`);
  }
}

export const contactService = new ContactService();
export default contactService;

